import React, { Suspense, lazy } from 'react';
import PrivateRoute from "../../routes/PrivateRoute";
import PublicRoute from "../../routes/PublicRoute";
import { Spinner } from '../Common/Spinner';
const EventList = lazy(() => import('./EventList'));
const EventInstructionPage = lazy(() => import('./EventInstructionPage'));
const EventDetailListTable = lazy(() => import('./EventDetails/EventDetailList'));
const AttendeeRsvpForm = lazy(() => import('./AttendeesRsvp/AttendeeRsvpForm'));
const AttendeeRsvpListTable = lazy(() => import('./AttendeesRsvp/AttendeeRsvpList'));

const EventRoute = (props) => (
  <Suspense fallback={<Spinner/>}>
    <PrivateRoute path="/list/events" searchString={props.searchString} component={EventList} exact />
    <PublicRoute path="/rsvp/registration/:organization_id/:event_id" component={AttendeeRsvpForm} exact />
    <PublicRoute path="/event/instruction/:organization_id/:event_id" component={EventInstructionPage} exact />
    <PrivateRoute path="/attendees/rsvp/:organization_id/:event_id" component={AttendeeRsvpListTable} exact />
  </Suspense>
)

export default EventRoute;